import { gql } from '@apollo/client/core'
import { useQuery } from '@vue/apollo-composable'
import { IMenuQuery, INodeNavigationResponse } from '@types'

const FIND_NODE_NAVIGATION_QUERY = gql`
  query FindNodeNavigation($id: ID!) {
    findNodeNavigation(id: $id) {
      type
      payload {
        ... on NodeNavigationResponse {
          nodeNavigation {
            id_parent
            title
            type
            children {
              id
              title
              type
            }
          }
        }
      }
    }
  }
`

export const useMenuQuery = (variables: IMenuQuery) => {
  const query = useQuery<INodeNavigationResponse>(FIND_NODE_NAVIGATION_QUERY, variables, {
    fetchPolicy: 'cache-first'
  })
  return query
}
